import TerceiroContext from "../context";
import { ReactElement, useContext, useMemo } from "react";
import { Textfield } from "../../Recompensas/components/Alteracao/ModalUI/fields";
import { Grid } from "@mui/material";
import DialogForm from "../../../components/DialogForm";
import { TerceiroForm } from "./types";
import { FormikHelpers } from "formik";
import { FuncTerceiro } from "../types";
import { toastfyError, toastfySuccess } from "../../../components/Toastfy";
import { validationForm } from "../../Recompensas/components/Alteracao/ModalUI/validation/schema";
import { employeeOutsourced } from "../../../service/requests/employeeOutsourced";

export default function ModalFunc() {
	const {
		setSelected,
		showEditModal,
		setShowEditModal,
		selectedEdit,
		setRefresh,
		refresh,
	} = useContext(TerceiroContext);

	const formValues = useMemo(() => {
		return {
			id: selectedEdit?.id,
			codFuncionario: selectedEdit?.codFuncionario,
			nome: selectedEdit?.nome,
			email: selectedEdit?.email,
			setor: selectedEdit?.setor,
			cargo: selectedEdit?.cargo,
			funcao: selectedEdit?.funcao,
			centroCusto: selectedEdit?.centroCusto,
			gestor: selectedEdit?.gestor,
			senha: selectedEdit?.senha,
		} as TerceiroForm;
	}, [selectedEdit]);

	const onSubmit = (
		values: TerceiroForm,
		helpers: FormikHelpers<TerceiroForm>
	) => {
		const model = {
			id: values?.id,
			codFuncionario: Number(values?.codFuncionario),
			nome: values?.nome,
			email: values?.email,
			setor: values?.setor,
			cargo: values?.cargo,
			funcao: values?.funcao,
			centroCusto: Number(values?.centroCusto),
			gestor: values?.gestor,
			senha: values?.senha,
		} as FuncTerceiro;

		if (model.id) {
			employeeOutsourced
				.put(model)
				.then(() => {
					setShowEditModal({ isVisible: false, mode: "" });
					helpers.setSubmitting(true);
					toastfySuccess("Funcionário editado com Sucesso!");
					setRefresh(!refresh);
				})
				.catch(() => {
					setShowEditModal({ isVisible: false, mode: "" });
					helpers.setSubmitting(false);
					toastfyError("Erro ao editar Funcionário!");
					setRefresh(!refresh);
				});
		} else {
			employeeOutsourced
				.create(model)
				.then(() => {
					setShowEditModal({ isVisible: false, mode: "" });
					helpers.setSubmitting(true);
					toastfySuccess("Funcionário Terceiro Criado Com Sucesso!");
					setRefresh(!refresh);
				})
				.catch(() => {
					setShowEditModal({ isVisible: false, mode: "" });
					helpers.setSubmitting(false);
					toastfyError("Erro ao Criar Funcionário!");
					setRefresh(!refresh);
				});
		}
	};

	const fields = (): ReactElement[] => {
		const fields: ReactElement[] = [];

		fields.push(
			<Grid item xs={6}>
				<Textfield name='nome' label='Nome' required />
			</Grid>
		);

		fields.push(
			<Grid item xs={6}>
				<Textfield name='codFuncionario' label='Código' required />
			</Grid>
		);

		fields.push(
			<Grid item xs={6}>
				<Textfield name='email' label='E-mail' required />
			</Grid>
		);

		fields.push(
			<Grid item xs={6}>
				<Textfield name='setor' label='Setor' required />
			</Grid>
		);

		fields.push(
			<Grid item xs={6}>
				<Textfield name='cargo' label='Cargo' required />
			</Grid>
		);

		fields.push(
			<Grid item xs={6}>
				<Textfield name='funcao' label='Função' required />
			</Grid>
		);

		fields.push(
			<Grid item xs={6}>
				<Textfield name='centroCusto' label='Centro Custo' required />
			</Grid>
		);

		fields.push(
			<Grid item xs={6}>
				<Textfield name='gestor' label='Gestor' required />
			</Grid>
		);

		fields.push(
			<Grid item xs={6}>
				<Textfield name='senha' label='Senha' required />
			</Grid>
		);

		return fields;
	};

	const handleCloseModal = () => {
		setSelected([]);
		setShowEditModal({ isVisible: false, mode: "" });
	};

	return (
		<DialogForm
			title={"Funcionários Terceiros"}
			open={showEditModal.isVisible}
			initialValues={formValues}
			fields={fields()}
			validationSchema={validationForm}
			width='sm'
			onSubmit={onSubmit}
			onClose={handleCloseModal}
		/>
	);
}
